<template lang="pug">
.hlm
  HomeNewsM(:tabs="tabData")
  SpecialM(:link="link")
  HomeVideo(:video="video")
  RCardM(:specialArticles="specialArticles")
</template>

<script>
import HomeNewsM from '../components/HomeNewsM'
import SpecialM from '../components/SpecialM'
import HomeVideo from '@/components/HomeVideo'
import RCardM from '@/components/RCardM'

export default {
  props: {
    link: {
      type: Array,
      default: []
    },
    video: {
      type: Object,
      default: null
    },
    tabData: {
      type: Array,
      default: []
    },
    specialArticles: {
      type: Array,
      default: []
    }
  },
  components: { HomeNewsM, SpecialM, HomeVideo, RCardM }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'

.hlm
  width: 100%
  +flexcolumn
  align-items: center

</style>


// WEBPACK FOOTER //
// src/components/HomeLinkM.vue